export const columns = (vm) =>{
    return [
        {
            width:50,
            headerAlign:"center",
            align:"center",
            type:'selection',
        },
        // {
        //   type: 'index',
        //   width: 50,
        //   label: '序号',
        //   headerAlign:"center",
        //   align:"center",
        // },
        {
            label:'姓名',
            prop:'name',
            align:'center',
            headerAlign:'center',
            tooltip:true,
        },
        {
            label:'用户账号',
            prop:'account',
            align:'center',
            headerAlign:'center',
        },
        {
            label:'手机号码',
            prop:'mobile',
            align:'center',
            headerAlign:'center',
            width:300,
        },
        {
            label:'所属平台',
            prop:'belongToType',
            align:'center',
            headerAlign:'center',
            width:300,
            render:(h,param)=>{
              let text = '';
              switch(param.row.belongToType){
                case 1:
                  text = '运营平台'
                break;
                case 2:
                  text = '工厂平台'
                return;
                case 3:
                  text = '代理商平台'
                return;
                case 4:
                  text = '工程商平台'
                return;
              }

              return h('div',{},text);
            }
        },
        {
            label:'项目角色',
            width:160,
            prop:'roleType',
            align:"center",
            headerAlign:"center",
            render:(h,param)=>{
              let txt = '';
              txt = param.row.roleType == 1?'超管':'普通角色';
              return h('div',{},txt);
            }
        },
        {
          label:'成员状态',
          width:160,
          prop:'roleType',
          align:"center",
          headerAlign:"center",
          render:(h,param)=>{
            let txt = '';
            let color = ''
            color = param.row.roleType == 1?'rgb(159, 211, 157)':'rgb(245, 108, 108)';
            txt = param.row.roleType == 1?'启用':'禁用';
            return h('div',{style:{color:color}},txt);
          }
      }
        // {
        //     label:'操作',
        //     width:120,
        //     align:"center",
        //     headerAlign:"center",
        //     render: (h, params) => {
        //         let del = (h)=>{
        //             return h('el-button',{
        //                 props:{
        //                     type:'text'
        //                 },
        //                 style:{
        //                     padding:0
        //                 },
        //                 on:{
        //                     click:()=>{vm.operateShow(2,params.row)}
        //                 }
        //             },'删除')
        //         }

        //         let query = (h)=>{
        //             return h('el-button',{
        //                 props:{
        //                     type:'text'
        //                 },
        //                 style:{
        //                     padding:0
        //                 },
        //                 on:{
        //                     click:()=>{vm.operateShow(1,params.row)}
        //                 }
        //             },'查看')
        //         }

        //         let btnArr = [];
        //         btnArr.push(query(h));
        //         btnArr.push(del(h));

        //         return h('div',{},btnArr)
        //     }
        // }
      ]
}